import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const PaylinkSkeleton: React.FC = () => (
  <div data-testid="paylink-skeleton">
    <Skeleton className="h-[25rem]" />
  </div>
);
